/* unplugin-vue-components disabled */import { render } from "./SvgIconNoteWithClip.vue?vue&type=template&id=d790d09c"
import script from "./SvgIconNoteWithClip.vue?vue&type=script&lang=js"
export * from "./SvgIconNoteWithClip.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__